import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NetworkStatusService } from '../services/network-status.service';

/**
 * Banner fixo de "sem conexão", dirigido pelo NetworkStatusService. Aparece só
 * quando o aparelho está offline, para o usuário entender o porquê das telas
 * não atualizarem, em vez de o app errar ou deslogar em silêncio.
 */
@Component({
  selector: 'app-offline-banner',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="offline-banner" *ngIf="(network.connected$ | async) === false">
      Sem conexão com a internet
    </div>
  `,
  styles: [`
    .offline-banner {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 99999;
      padding: 8px 12px;
      background: #b00020;
      color: #fff;
      text-align: center;
      font-size: 14px;
    }
  `],
})
export class OfflineBannerComponent {
  constructor(public network: NetworkStatusService) {}
}
